"use client";

import { Layout } from "antd";
import LoadingScreen from "@/components/loadingScreen";

interface LoadingProps {
	message?: string;
	className?: string;
}

// Root route fallback + game-launch loader (game/PlayGame passes `message`).
// The shared LoadingScreen on the layout background: these routes render
// outside the authenticated shell, which otherwise provides it.
export default function Loading({ message, className = "" }: LoadingProps) {
	return (
		<Layout className={className}>
			<LoadingScreen label={message || undefined} />
		</Layout>
	);
}
